export enum PosterEditingNavbarMode {
  DEFAULT = 'DEFAULT',
  REGEN = 'REGEN',
  EMBEDDED = 'EMBEDDED',
  VERSION_HISTORY = 'VERSION_HISTORY',
}
